import { render, staticRenderFns } from "./billDialog.vue?vue&type=template&id=45bccab2&scoped=true&"
import script from "./billDialog.vue?vue&type=script&lang=js&"
export * from "./billDialog.vue?vue&type=script&lang=js&"
import style0 from "./billDialog.vue?vue&type=style&index=0&id=45bccab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bccab2",
  null
  
)

export default component.exports